import {ROLES} from 'constants/enum/userRoles'
import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const email = {
    name: 'email',
    rules: {required: true},
    sm: 6,
}

const role = {
    name: 'role',
    type: 'select',
    label: 'role',
    options: ROLES,
    withTranslation: true,
    rules: {required: true},
    sm: 6,
}
export const createInviteField = {
    createInvite: {
        title: 'inviteUser',
        items: {email, role},
    },
}

export const createInviteFieldValidation = z.object({
    email: ZodConfig.string(),
    role: ZodConfig.enum(ROLES),
})
